
// import { parseTime } from './ruoyi';
import { Message, Loading } from 'element-ui';
import { jsonp } from 'vue-jsonp';


export function cityNameFormat(name){
  name = name.replace(/(.+)[藏|壮|傣]族.{1,2}族自治州/g,"$1");
  name = name.replace(/(.+)((.{2}族.{1,2}族)|蒙古)自治州/g,"$1");
  name = name.replace(/(.+)[回|藏|藏|彝|傣|白]族自治州/g,"$1");
  name = name.replace(/(.+)(.{2}族)自治州/g,"$1");
  name = name.replace(/(.{2,10})市/g,"$1");
  name = name.replace(/地区|自治州/g,"");
  return name;
}

export function createMap(){
  return new Promise((resolve)=>{
    if(document.getElementById('createMapID') || document.getElementById('createMapID2')){
      resolve();
      return;
    }
    const mapScript = document.createElement('script');
    mapScript.type = 'text/javascript';
    mapScript.setAttribute('charset','utf-8')
    mapScript.setAttribute('id','createMapID')
    mapScript.src = 'https://map.qq.com/api/gljs?v=1.exp&key=U2GBZ-L6IW6-BZSSX-EUPWF-UUZ7Z-MNB3T&libraries=geometry';
    console.log("创建map",mapScript.src)
    document.head.appendChild(mapScript);
    mapScript.onload = () =>{
      resolve();
    }
    
    mapScript.onerror = ()=>{
      const localScript = document.createElement('script');
      localScript.type = 'text/javascript';
      localScript.setAttribute('id','createMapID2')
      localScript.src = 'https://mp-259c7098-a6bf-4ac9-bdb4-ce7b7e3a457e.cdn.bspapp.com/static/mobile_map/gljs.js';
      document.head.appendChild(localScript);
      resolve();
    }
  })
}
/* 创建定位实例 */
export function createGeolocation(){
  return new Promise((resolve)=>{
    const mapScript = document.createElement('script');
    mapScript.type = 'text/javascript';
    // mapScript.src = 'https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js';
    mapScript.src = 'https://mapapi.qq.com/web/mapComponents/geoLocation/v/geolocation.min.js';
    document.body.appendChild(mapScript);
    mapScript.onload = () =>{
      resolve();
    }
  })
}

function getCurrentPosition(){
  return new Promise((resolve,reject) => {
    plus.geolocation.getCurrentPosition(res=>{
      console.log("index.js获取当前定位",res && JSON.stringify(res))
      if(res.coords.latitude === 5e-324 || res.coords.longitude === 5e-324) {
        reject(res);
      }else {
        let position = {
          lat:res.coords.latitude,
          lng:res.coords.longitude
        }
        resolve(position)
      }
    }, err=>{
      console.log('获取定位错误',JSON.stringify(err));
      reject(err)
    }, {
      enableHighAccuracy:true,  //高精度
      // timeout:10000,
      // coordsType:"gcj02",
      coordsType:"wgs84",
      geocode:false, //是否解析地址
      provider: "system"
    });
  })
}

function qqMapTranslate(params){
  return jsonp('https://apis.map.qq.com/ws/coord/v1/translate', {
    key: 'U2GBZ-L6IW6-BZSSX-EUPWF-UUZ7Z-MNB3T',
    output: 'jsonp',
    ...params
  })
}

/* 获取当前定位 */
export async function handleGetLocation(options){
  try {
    let gpsData = await getCurrentPosition();
    let gcj02Data = await qqMapTranslate({
      locations: `${gpsData.lat},${gpsData.lng}`,
      type: 1,  //1:GPS坐标 2:sogou经纬度 3:baidu经纬度 4:mapbar经纬度 6:sogou墨卡托
    });
    return Promise.resolve(gcj02Data.locations[0]);
  } catch (error) {
    return Promise.reject(error);
  }
}

/* 开启位置监听 谨慎打开注释，因为会出现小程序无法打开页面https://apis.map.gg.com/tools/geolocation?key=U2GBZ-L6IW6-BZSSX-EUPWF-UUZ7ZNB3T&amp:referer=mobile_map_beecargo_address*/
export function watchPosition(){
  // return new Promise((resolve,reject) => {
  //   var geolocation = new qq.maps.Geolocation("U2GBZ-L6IW6-BZSSX-EUPWF-UUZ7Z-MNB3T", "mobile_map_beecargo_address_book"); 
  //   geolocation.watchPosition(position => {
  //     resolve(position)
  //   });
  // })
}

/* 关闭位置监听 谨慎打开注释，因为会出现小程序无法打开页面https://apis.map.gg.com/tools/geolocation?key=U2GBZ-L6IW6-BZSSX-EUPWF-UUZ7ZNB3T&amp:referer=mobile_map_beecargo_address*/
export function clearWatch(){
  // return new Promise((resolve,reject) => {
  //   var geolocation = new qq.maps.Geolocation("U2GBZ-L6IW6-BZSSX-EUPWF-UUZ7Z-MNB3T", "mobile_map_beecargo_address_book"); 
  //   geolocation.clearWatch();
  // })
}

export function tansParamsNotEnCode(params) {
	let result = ''
	for (const propName of Object.keys(params)) {
		const value = params[propName];
		var part = propName + "=";
		if (value !== null && typeof (value) !== "undefined") {
			if (typeof value === 'object') {
				for (const key of Object.keys(value)) {
					if (value[key] !== null && typeof (value[key]) !== 'undefined') {
						let params = propName + '[' + key + ']';
						var subPart = params + "=";
						result += subPart + value[key] + "&";
					}
				}
			} else {
				result += part + value + "&";
			}
		}
	}
	return result
}


// 日期格式化
export const parseTime = function(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm),'');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}


/**
 * 表格时间格式化
 */
export function formatDate(cellValue) {
  if (cellValue == null || cellValue == "") return "";
  var date = new Date(cellValue) 
  var year = date.getFullYear()
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() 
  var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() 
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() 
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
	let result = ''
	for (const propName of Object.keys(params)) {
		const value = params[propName];
		var part = encodeURIComponent(propName) + "=";
		if (value !== null && typeof (value) !== "undefined") {
			if (typeof value === 'object') {
				for (const key of Object.keys(value)) {
					if (value[key] !== null && typeof (value[key]) !== 'undefined') {
						let params = propName + '[' + key + ']';
						var subPart = encodeURIComponent(params) + "=";
						result += subPart + encodeURIComponent(value[key]) + "&";
					}
				}
			} else {
				result += part + encodeURIComponent(value) + "&";
			}
		}
	}
	return result
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

export function makeMap(str, expectsLowerCase) {
  const map = Object.create(null)
  const list = str.split(',')
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true
  }
  return expectsLowerCase
    ? val => map[val.toLowerCase()]
    : val => map[val]
}
 
export const exportDefault = 'export default '

export const beautifierConf = {
  html: {
    indent_size: '2',
    indent_char: ' ',
    max_preserve_newlines: '-1',
    preserve_newlines: false,
    keep_array_indentation: false,
    break_chained_methods: false,
    indent_scripts: 'separate',
    brace_style: 'end-expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: false,
    end_with_newline: true,
    wrap_line_length: '110',
    indent_inner_html: true,
    comma_first: false,
    e4x: true,
    indent_empty_lines: true
  },
  js: {
    indent_size: '2',
    indent_char: ' ',
    max_preserve_newlines: '-1',
    preserve_newlines: false,
    keep_array_indentation: false,
    break_chained_methods: false,
    indent_scripts: 'normal',
    brace_style: 'end-expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: true,
    end_with_newline: true,
    wrap_line_length: '110',
    indent_inner_html: true,
    comma_first: false,
    e4x: true,
    indent_empty_lines: true
  }
}

// 首字母大小
export function titleCase(str) {
  return str.replace(/( |^)[a-z]/g, L => L.toUpperCase())
}

// 下划转驼峰
export function camelCase(str) {
  return str.replace(/_[a-z]/g, str1 => str1.substr(-1).toUpperCase())
}

export function isNumberStr(str) {
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(str)
}
 
// ===============tms======================
// import { Loading } from 'element-ui';
// export function resetForm(refName) {
//   this[refName] = {}
//   if (this.$refs[refName] !== undefined) {
//     this.$refs[refName].resetFields()
//   }
// }
// 挂载到Data的原型上进行调用
// 示例var time1 = new Date().format("yyyy-MM-dd hh:mm:ss");
export function format(fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

// export function loading() {
//   let loading = undefined
//   return {
//     open: () => {
//       return loading= Loading.service({
//         lock: true,
//         text: '加载中...',
//         spinner: 'el-icon-loading',
//         background: 'rgba(0, 0, 0, 0.7)'
//       });
//     },
//     close: () => {
//       if(loading){
//         loading.close()
//       }
//     }
//   }
// }

export function headerColor() {
  return  'background: #DFE4F2;  color: #333';
}

export function orderTypeName(val) {
  if(val===1) return '国内货运';
  if(val===2) return '拼车';
  if(val===3) return '进口-港口';
  if(val===4) return '进口-陆路关';
  if(val===5) return '出口-港口';
  if(val===6) return '出口-陆路关';
}

export function copyText(text){
  let oInput = document.createElement('input');
  oInput.value = text;
  document.body.appendChild(oInput);
  oInput.select();  //选择对象
  document.execCommand('Copy');
  Message({message:'复制成功',type:'success'});
  oInput.remove();
}

export function loading(){
  let loading = undefined;
  return {
    open:()=>{
      return loading = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    close:()=>{
      loading && loading.close();
    }
  }
}

export function zeroPadding(num){
	if(!num) return "0.00";
	num = num+"";
	let pointArr = num.split(".");
	if(pointArr.length === 1) return `${num}.00`;
	return `${pointArr[0]}.${pointArr[1].length >= 2 ? pointArr[1] : pointArr[1] + "0"}`
};

export function queryParams(data = {}, isPrefix = true, arrayFormat = 'brackets') {
	let prefix = isPrefix ? '?' : ''
	let _result = []
	if (['indices', 'brackets', 'repeat', 'comma'].indexOf(arrayFormat) == -1) arrayFormat = 'brackets';
	for (let key in data) {
		let value = data[key]
		// 去掉为空的参数
		if (['', undefined, null].indexOf(value) >= 0) {
			continue;
		}
		// 如果值为数组，另行处理
		if (value.constructor === Array) {
			// e.g. {ids: [1, 2, 3]}
			switch (arrayFormat) {
				case 'indices':
					// 结果: ids[0]=1&ids[1]=2&ids[2]=3
					for (let i = 0; i < value.length; i++) {
						_result.push(key + '[' + i + ']=' + value[i])
					}
					break;
				case 'brackets':
					// 结果: ids[]=1&ids[]=2&ids[]=3
					value.forEach(_value => {
						_result.push(key + '[]=' + _value)
					})
					break;
				case 'repeat':
					// 结果: ids=1&ids=2&ids=3
					value.forEach(_value => {
						_result.push(key + '=' + _value)
					})
					break;
				case 'comma':
					// 结果: ids=1,2,3
					let commaStr = "";
					value.forEach(_value => {
						commaStr += (commaStr ? "," : "") + _value;
					})
					_result.push(key + '=' + commaStr)
					break;
				default:
					value.forEach(_value => {
						_result.push(key + '[]=' + _value)
					})
			}
		} else {
			_result.push(key + '=' + value)
		}
	}
	return _result.length ? prefix + _result.join('&') : ''
}

export function sleep(time){
  if(!time) return Promise.resolve();
  return new Promise(resolve => {
    setTimeout(() => resolve() , time);
  })
}

export function plusReady() {  
  return new Promise(resolve=>{
    window.plus ? resolve() : document.addEventListener('plusready', resolve);
  })
};

export function getProperty(){
  return new Promise(resolve => {
    plus.runtime.getProperty( plus.runtime.appid, resolve );
  })
};

// 将分钟数转化为xx小时xx分钟
export function formatMinutes(value){
  if(value < 60){
    return value+'分钟';
  }else{
    let hour = parseInt(value / 60);
    let minute = value % 60;
    return (hour<10?'0'+hour:hour) + '小时' + (minute<10?'0'+minute:minute) + '分钟';
  }
}

// 分离文件名和扩展名
export function splitFileName(fileName) {
  if(!fileName) return { name: "" , extension: "" };
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex === -1) {
      return {
          name: fileName,
          extension: ""
      };
  }
  const name = fileName.slice(0, lastDotIndex);
  const extension = fileName.slice(lastDotIndex + 1);
  return {
      name,
      extension
  };
}

//把字节转换成正常文件大小
export function fileSizeFormat(size) {
  if (!size) return "";
  var num = 1024.00; //byte
  if (size < num)
      return size + "B";
  if (size < Math.pow(num, 2))
      return (size / num).toFixed(2) + "KB"; //kb
  if (size < Math.pow(num, 3))
      return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
  if (size < Math.pow(num, 4))
      return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
  return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
}

export function getStatusBarHeight() {
  // 判断是否在iOS设备上
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  if (isIOS) {
    // iOS设备可以通过viewport属性来获取状态栏高度
    const windowHeight = window.innerHeight;
    const screenHeight = screen.height;
    
    // 计算差值作为状态栏高度
    const statusBarHeight = Math.abs(screenHeight - windowHeight);
    
    // 确保结果合理
    return statusBarHeight > 0 ? statusBarHeight : 20; // 默认20px
  } else {
    // Android设备通常没有可靠的JavaScript方法直接获取状态栏高度
    // 可以通过CSS变量获取，但需要配合viewport-fit=cover
    const statusBarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--status-bar-height'));
    
    // 如果获取失败，返回一个估计值
    return isNaN(statusBarHeight) ? 24 : statusBarHeight; // 默认24px
  }
}

/**
 * 压缩图片
 * @param {String} src 图片的绝对路径或相对路径
 * @returns {Promise}
 */
export function compressImage(src) {
	return new Promise((resolve, reject) => {
		// #ifdef APP-PLUS
		// 动态生成目标路径，存放在应用私有目录
		const dst = `_doc/compressed/img_${Date.now()}.jpg`; 
	
		plus.zip.compressImage({
				src: src,      // 源图片路径
				dst: dst,      // 压缩后图片的输出路径
				overwrite: true, // 是否覆盖目标路径文件
				quality: 50,     // 压缩质量，范围 1-100，越小越模糊
				width: 'auto',   // 缩放宽度，支持像素('1080px')或百分比('50%')，'auto'为保持原比例
				height: 'auto'   // 缩放高度
			},
			(event) => {
				// 压缩成功
				// event.target: 压缩后的图片路径
				// event.size: 压缩后图片的大小（字节）
				// event.width / event.height: 压缩后的宽高
				resolve(event);
			},
			(error) => {
				// 压缩失败
				console.error("压缩失败: ", error);
				reject({
					error,
					msg: "压缩图片失败"
				});
			}
		);
		// #endif
	// #ifndef APP-PLUS
	resolve({ target: src, size: 0 });
	// #endif
	});
}

/**
 * 将 blob URL 转为带正确文件名的 File 对象（H5 专用）
 * @param {String} blobUrl - blob URL
 * @param {String} fileName - 目标文件名（含扩展名）
 * @returns {Promise<File>}
 */
export function blobUrlToFile(blobUrl, fileName) {
	return fetch(blobUrl)
		.then(res => res.blob())
		.then(blob => new File([blob], fileName, { type: blob.type }));
}